<div class="p-1 verification-validation" [ngClass]="{ 'alert alert-danger': hasError }">
  <ng-content />
  @if (errorMessage) {
    <p class="form-text text-danger">
      <strong>{{ errorMessage }}</strong>
    </p>
  }
</div>
